import { Issuer, IPaginationResponse } from "../types";
import { rootApi } from "../rootApi";
import { IIssuersParams } from "./types";

export const issuerApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    issuer: builder.query<Issuer, { id: string }>({
      query: ({ id }) => ({
        url: `issuers/${id}/`,
      }),
      providesTags: (_result, _, arg) => [{ type: "issuer", id: arg.id }],
    }),
    issuers: builder.query<IPaginationResponse<Issuer>, IIssuersParams>({
      query: ({ offset, limit, ordering, type }) => ({
        url: `issuers/`,
        params: {
          offset,
          limit,
          ordering,
          type: type || undefined,
        },
      }),
      providesTags: ["issuer"],
    }),
  }),
});

export const { useIssuerQuery, useIssuersQuery } = issuerApis;
